<template>

  <h2>List of persons with a status of Complete on this Contract</h2>

  <div class="returnLinkButton">
    <div class="material-icons forIconEdit text-success"> arrow_back_ios_new </div>
    <a herf="#" class="text-primary" @click="ReturnToProcessMasterListPage">
      Return to Process Master List Page
    </a>
  </div>

  <ContractHelperComponent v-if="this.retrievedContractInfo" :prop-contract-info="contractInfo"></ContractHelperComponent>

  <DataTableComponent v-if="this.getAllUrl" 
  :data-url="this.getAllUrl" 
  :column-list-d-b="this.personDataColumnNames" 
  :column-list-pretty="this.personDataColumnNamesPretty" 
  column-name-id="personId" 
  ref="personsDatatable"
  :show-paging="false"
  :rows-per-page="-1"
  plural-data-name="people"
  :order-column-index="0" 
  order-direction="asc"
  >
    
    <template v-slot:extraColumnHeaders>
      <th>Upload Weapon Permit</th>
    </template>

    <template #extraColumns="extraColumnRowData">
      <td :data-sort="extraColumnRowData.lrNotes">
        
        <div class="text-primary" @click="this.ClickedUploadWeaponPermit(extraColumnRowData)">Upload</div>
        
      </td>
    </template>

    <template #actionColumnEditSlot="actionColumnEditSlot">

      
        <td class="tdclass actionColumn">
          <div class="text-primary" @click="this.ClickedEditPerson(actionColumnEditSlot)" :id="'btnEditPerson_' + actionColumnEditSlot.personId">Edit </div>
        </td>
     

    </template>

  </DataTableComponent>

</template> 
  
<script> 
  
  import { store } from "@/store/store.js";
  import $ from "jquery";
  import { ajaxGetAndReturn } from "@/components/helpers/utilities";
  import DataTableComponent from "@/components/dataSupport/DataTable.vue";
  import ContractHelperComponent from "@/components/ContractHelper/ContractHelper.vue";
  import TooltipHelper from "@/components/dataSupport/TooltipHelper.vue";
  //import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue"

  export default {
    name: "PersonsByContractQC",
    components: {
      DataTableComponent,
      ContractHelperComponent,
      TooltipHelper,
    }, 
    data(){
      return{
        store,
        contractInfo: {},
        getAllUrl:"",
        personDataColumnNames:['lastName','firstName', 'contractNumber'],
        personDataColumnNamesPretty:['Last Name','First Name', 'Contract Number'],
        retrievedContractInfo:false,
        isMounted: false
      }
    },
    computed:{
      contractId(){
        var computedValue = 0; 

        if(this.store.tempContractId != undefined &&this.store.tempContractId != 0){
          computedValue = this.store.tempContractId;
        }
        else{
          computedValue = this.$route.params.contractId;
        }

        return computedValue;
      },
      companyId(){
        var computedValue = 0; 
        console.log("getting company id"); 
        if(this.store.tempCompanyId != undefined &&this.store.tempCompanyId != 0){
          computedValue = this.store.tempCompanyId;
        }
        else{
          computedValue = this.$route.params.companyId;
        }

        return computedValue;
      }
    },
     created(){
      ///contracts/getHelperDto/{contractId}
   
      ajaxGetAndReturn(store.webAPIUrl + "contracts/getHelperDto/" + this.contractId, (result) =>{
        //console.log(result);
        this.contractInfo = result;
        this.retrievedContractInfo = true; 
      });

      this.getAllUrl = store.webAPIUrl + "people/GetAllPersonsByContractAndStatus?contractId=" + this.contractId + "&statusFilter=Complete";

    },
    mounted() {
      //var urlParams = this.$route.params.contractId;
       
      $("");
      
      this.isMounted = true;
    },

    methods:{
      ClickedEditPerson(_person){
        this.store.tempPersonId = _person.personId;
        this.$router.push({ name: 'PersonEditPage', params: { personId: _person.personId } })  
      },
      ReturnToProcessMasterListPage(){
        this.$router.push({ name: 'processMasterList' });
      }, 
      ClickedUploadWeaponPermit(_person){

        alert("Development of this functionality in Progress (Clicked Upload Weapon Permit for Person: " + _person.lastName + ", " + _person.firstName + ")");
      }
    },
    unmounted(){

      //console.log("force update user contracts table"); 
      this.$forceUpdate();
    }
  }
</script>
  
<style scoped>
  .returnLinkButton{
    display:flex;
    margin-bottom:15px;
  }
  .actionButton{
    width:max-content;
    padding:5px;
    cursor:pointer;
  }
  .actionButton{
    padding:5px;
  }
  .acodNotesContainer{
    display:flex;
    flex-direction: column;
    text-align:left;
  }
  .acodNote{
    white-space:pre-wrap
  }
</style>
